import Vue from "vue";
import debounce from "lodash/debounce";
import { getSearchResults } from "../../client-app/src/common/api";

function initSearch() {
    var el = document.getElementById("header-search");

    if (!el) return;

    var app = new Vue({
        el: el,
        delimiters: ["${", "}"],
        data: {
            results: null,
            loading: false,
            searching: false,
            showDropdown: false,
        },
        mounted: async function () {
            // console.log("👍 Header search mounted");
        },
        computed: {},
        methods: {
            updateSearchQuery: async function (event) {
                const noInteract = [
                    "Escape",
                    "Shift",
                    "Enter",
                    "CapsLock",
                    "Meta",
                    "Control",
                    "Alt",
                    "ArrowLeft",
                    "ArrowRight",
                    "ArrowDown",
                    "ArrowUp",
                ];

                // Only allow normal character input
                if (noInteract.indexOf(event.key) > -1) {
                    return;
                }

                this.searching = true; // show search loader
                this.results = []; // clear results
                this.fetchSearchResults(event.target.value); // fetch data
            },
            fetchSearchResults: debounce(async function (query) {
                // If we have a query, run it, else set results to "null" so we can display our "search current location" link
                if (query.length > 0) {
                    let result = await getSearchResults(query);
                    this.results = result.body;
                } else {
                    this.results = null;
                }

                this.searching = false;
            }, 500),
        },
    });
}

export default function () {
    initSearch();
}
